/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../axios-client";
import type { PostApiBookingTabletMutationRequest, PostApiBookingTabletMutationResponse, PostApiBookingTabletQueryParams, PostApiBookingTablet400, PostApiBookingTablet403, PostApiBookingTablet404, PostApiBookingTablet500 } from "../entities/PostApiBookingTablet";
import type { UseMutationOptions, UseMutationResult, QueryClient } from "@tanstack/react-query";
import { postApiBookingTablet } from "../api/postApiBookingTablet";
import { mutationOptions, useMutation } from "@tanstack/react-query";

export const postApiBookingTabletMutationKey = () => [{ url: '/api/booking/tablet' }] as const

export type PostApiBookingTabletMutationKey = ReturnType<typeof postApiBookingTabletMutationKey>

export function postApiBookingTabletMutationOptions<TContext = unknown>(config: Partial<RequestConfig<PostApiBookingTabletMutationRequest>> & { client?: Client } = {}) {

        const mutationKey = postApiBookingTabletMutationKey()
        return mutationOptions<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, {data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams}, TContext>({
          mutationKey,
          mutationFn: async({ data, params }) => {
            return postApiBookingTablet(data, params, config)
          },
        })

}

/**
 * @description Создание записи без телефона в выбранном филиале: услуга компании по типу, ближайшее время, single/parallel/sequential
 * @summary Создать запись с планшета
 * {@link /api/booking/tablet}
 */
export function usePostApiBookingTablet<TContext>(options: 
{
  mutation?: UseMutationOptions<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, {data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams}, TContext> & { client?: QueryClient },
  client?: Partial<RequestConfig<PostApiBookingTabletMutationRequest>> & { client?: Client },
}
 = {}) {

          const { mutation = {}, client: config = {} } = options ?? {}
          const { client: queryClient, ...mutationOptions } = mutation;
          const mutationKey = mutationOptions.mutationKey ?? postApiBookingTabletMutationKey()

          const baseOptions = postApiBookingTabletMutationOptions(config) as UseMutationOptions<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, {data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams}, TContext>
          

          return useMutation<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, {data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams}, TContext>({
            ...baseOptions,
            mutationKey,
            ...mutationOptions,
          }, queryClient) as UseMutationResult<PostApiBookingTabletMutationResponse, ResponseErrorConfig<PostApiBookingTablet400 | PostApiBookingTablet403 | PostApiBookingTablet404 | PostApiBookingTablet500>, {data: PostApiBookingTabletMutationRequest, params: PostApiBookingTabletQueryParams}, TContext>
      
}